import { useState } from "react"

import { Circle, Eraser, MousePointer2, Paintbrush, Send, Square } from "@/components/icons"
import { cn } from "@/lib/utils"

const TOOLS = [
  { icon: MousePointer2, id: "select" },
  { icon: Paintbrush, id: "brush" },
  { icon: Square, id: "rect" },
  { icon: Circle, id: "ellipse" },
  { icon: Eraser, id: "clear" },
]

export function DemoImageEditor() {
  const [activeTool, setActiveTool] = useState("brush")

  return (
    <div className="bg-card w-full overflow-hidden rounded-xl border">
      <div className="flex">
        {/* Toolbar */}
        <div className="flex flex-col gap-1 border-r p-2">
          {TOOLS.map(({ icon: Icon, id }) => (
            <button
              key={id}
              type="button"
              className={cn(
                "flex h-9 w-9 items-center justify-center rounded-lg transition-colors",
                activeTool === id
                  ? "border-foreground bg-primary text-primary-foreground border"
                  : "hover:bg-muted"
              )}
              onClick={() => setActiveTool(id)}
            >
              <Icon className="h-4 w-4" />
            </button>
          ))}
        </div>

        {/* Canvas area */}
        <div className="flex flex-1 flex-col">
          <div className="bg-muted/20 flex aspect-video items-center justify-center border-b">
            <div className="flex flex-col items-center gap-2">
              <div className="bg-muted flex h-24 w-24 items-center justify-center rounded-xl">
                <Paintbrush className="text-muted-foreground h-8 w-8" />
              </div>
              <p className="text-muted-foreground text-xs">Select area to edit with AI</p>
            </div>
          </div>

          {/* AI Edit input */}
          <div className="flex items-center gap-2 p-3">
            <input
              readOnly
              className="text-muted-foreground bg-muted flex-1 rounded-lg border px-3 py-2 text-sm"
              placeholder="Describe your edit..."
              type="text"
              value=""
            />
            <button
              className="border-foreground bg-primary text-primary-foreground flex h-9 w-9 items-center justify-center rounded-lg border"
              type="button"
            >
              <Send className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
